/**
 * This is a row in the GovernanceDocuments.js component table
 * It displays documents type(icon), name and creation date.
 * If it is unread, the name is bold
 * Nested components: TreeView.js and GovernanceDocuments.js
 * This component is loaded by clicking the category in the TreeView.js nested in the Governance.js (TreeRow.js).
 */

import React from 'react';
import { getFormattedTimeYear, checkURL } from '../../../../../helpers/utils';
import { HTML_DOC_TYPE, DOC_TYPE_GOVERNANCE } from '../../../../../helpers/constants';
import { apiDownloadNativeDoc } from '../../../../../helpers/api';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import './../ContentMenu.css';
import store from '../../../../../stores/store';
import * as local from '../../../../../helpers/localStorage';
import SaveAsButton from '../../../Meeting/components/SaveAsButton'
import { Online, Offline } from '../../../../_shared/conn';

let fs
let dialog
if (window.require) {
    fs = window.require('fs')
    let remote = window.require('electron').remote
    dialog = remote.dialog
}

const CustomRow = observer(
    class CustomRow extends React.Component {
        /**
         * It runs on selection of a document
         * It propagates event to the GovernanceDocuments.js
         * and up to the Governance.js func onDocumentClick (handler).
         * @param  {number} Id governance document Id
         */

        constructor() {
            super();
            this.state = {
                downloadDropdown: false
            }
        }

        onClick = () => {
            if (this.props.onDocumentClick) {
                this.props.onDocumentClick(
                    this.props.Document.Id,
                    this.props.Document.DocExtension,
                    this.props.Document.DocPermissions,
                    this.props.Document.DocName,
                    this.props.Document.DocAnnotations,
                    this.props.Document.DocType,
                );
            }
        };

        onLinkClick = () => {
            store.groups.makeDocumentRead(this.props.Document.Id);
        };

        canDownloadNative = () => {
            const permissions = this.props.Document.DocPermissions;

            return ((permissions & 32) === 32)
        }

        canDownload = () => {
            const permissions = this.props.Document.DocPermissions;

            return ((permissions & 4) === 4)
        }

        toggleDownloadDropdown = () => {
            this.setState({
                downloadDropdown: !this.state.downloadDropdown
            })
        }

        downloadOriginal = async () => {
            const instanceId = store.companies.selectedId;
            const docTypeId = DOC_TYPE_GOVERNANCE;
            const doc = this.props.Document
            const docId = doc.Id

            const result = await apiDownloadNativeDoc(store.user.token,{docId, instanceId, docTypeId})
            const content = result.body
            console.log("result", result);
            console.log("content: ", content);
            
            if (fs && dialog) {
                const savedFilePath = dialog.showSaveDialog(null, { defaultPath: doc.DocName + "." + doc.DocExtension })
                if (savedFilePath != null) {
                    fs.writeFile(savedFilePath, content, (err) => {
                    })
                }
            }
        }

        downloadPDF = async () => {
            const instanceId = store.companies.selectedId;
            const docTypeId = DOC_TYPE_GOVERNANCE;
            const doc = this.props.Document
            const docId = doc.Id
            const DocExtension = doc.DocExtension
            const DocPermissions = doc.DocPermissions
            const DocName = doc.DocName

            const result = await store.documents.downloadAndDecryptDocument({
                instanceId, docTypeId, docId, DocExtension, DocPermissions, DocName
            })
            console.log("res", result);

            if (fs && dialog) {
                const savedFilePath = dialog.showSaveDialog(null, { defaultPath: this.props.fileName + ".pdf" })
                if (savedFilePath != null) {
                    fs.writeFile(savedFilePath, result, (err) => {
                    })
                }
            }
        }

        render() {
            let docType = this.props.Document.DocType;
            let docUrl = this.props.Document.DocUrl;
            let docXtn = '.' + this.props.Document.DocExtension;
            //let permissions = this.props.Document.DocPermissions;
            const instanceId = store.companies.selectedId;
            const GroupId = store.groups.selectedGroup.GroupId;
            const key =
                local.LS_GOVERNANCE_DOWNLOADED +
                instanceId +
                GroupId +
                store.user.profile[0].UserId;
            const isDocumentDownloaded = local.isKeyExists(key, this.props.Document.Id);

            return (
                <tr>
                    <td scope="row">
                        {docType === HTML_DOC_TYPE ? (
                            <div style={{ width:'100%' }}>
                            <Online>
                                <a
                                    onClick={this.onLinkClick}
                                    className={`doc-clickable-block ${
                                        this.props.Document.IsRead ? '' : 'doc-unread'
                                        }`}
                                    target="__blank"
                                    title={docXtn}
                                    href={checkURL(docUrl)}
                                >
                                    {this.props.Document.DocName}
                                </a>
                                </Online>
                                <Offline>
                                    <a title="! OFFLINE" className={`doc-clickable-block ${this.props.Document.IsRead ? '' : 'doc-unread'}`}>
                                    {this.props.Document.DocName}
                                    </a>
                                </Offline>
                            </div>
                        ) : (

                                <div className="d-flex justify-content-around w-100">
                                    <div
                                        className={`doc-clickable-block ${
                                            this.props.Document.IsRead ? '' : 'doc-unread'
                                            } ${isDocumentDownloaded ? 'icon-download-success' : ''}`}
                                        onClick={this.onClick}
                                        title={docXtn}
                                    >
                                        {this.props.Document.DocName}
                                    </div>
                                    <SaveAsButton document={this.props.Document} docTypeId={ DOC_TYPE_GOVERNANCE }/>
                                </div>
                            )}
                    </td>
                    <td className="small" id={this.props.Document.DocModified}>
                        {getFormattedTimeYear(this.props.Document.DocModified)}
                    </td>
                </tr>
            );
        }
    },
);

CustomRow.propTypes = {
    onDocumentClick: PropTypes.func,
};

export default CustomRow;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/Governance/CustomRow.js